export default "__VITE_ASSET__D$VjzTa___"